import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Experience Freshness with Our Laundry Services"} subTitle={"Fresh. Fast. Clean"} linear sideHeading />
        <Button link={"Get-Quote"} title={"Get A Quote"} />

      </div>
    </section>
  );

};

export default Banner;